"use client";
import { Flex, Stack, StackProps, Text, TextProps } from "@chakra-ui/react";

export interface CardHeaderProps extends Omit<StackProps, "title"> {
  title: React.ReactNode;

  titleProps?: TextProps;
  subtitle?: React.ReactNode;

  subtitleProps?: TextProps;

  date?: React.ReactNode;
  dateProps?: TextProps;
}
export const CardHeader: React.FC<CardHeaderProps> = ({
  title,
  titleProps,
  date,
  dateProps,
  subtitle,
  subtitleProps,
  children,
  ...props
}) => {
  return (
    <Stack p="24px 24px 0" {...props}>
      <Flex alignItems="center" gap={3}>
        <Text as="h6" apply="styles.widgetStyles.h6" {...titleProps}>
          {title}
        </Text>
        <Text as="p" apply="styles.widgetStyles.body2" {...dateProps}>
          {date}
        </Text>
      </Flex>

      {subtitle && (
        <Text
          as="p"
          apply="styles.widgetStyles.body2"
          mt="0.5"
          {...subtitleProps}
        >
          {subtitle}
        </Text>
      )}
      {children}
    </Stack>
  );
};
